// extracted by mini-css-extract-plugin
export default {"order":"OrderingButton_order__kRQGm","order__ascending":"OrderingButton_order__ascending__WeSWi"};